import React from "react";
import { FaWhatsapp, FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "./connect.css";

function Connect() {
  return (
    <>
   
    <div className="connect-section" style={{ marginTop:"30px"}}>
      <div className="container connect-container">
        {/* <h4>Connect with us</h4> */}
          <section >
      <div className='heading-head'>
        <h3 className='heading-h3'>Connect with us</h3>
          {/* <div className="underline-oueclient"></div> */}
       </div>  
    
    </section>
        <p>We’re here to help you! Reach out to us via WhatsApp, call, or email.</p>
        <div className="connect-buttons">
          <a href="https://wa.me/918870519755" target="_blank" rel="noopener noreferrer">
            <button className="connect-btn whatsapp">
              <FaWhatsapp className="icon" /> WhatsApp
            </button>
          </a>
          <a href="tel:+918870519755">
            <button className="connect-btn call">
              <FaPhoneAlt className="icon" /> Call us
            </button>
          </a>
          <a href="mailto:pria23sRATH@gmail.com">
            <button className="connect-btn email">
              <FaEnvelope className="icon" /> Email
            </button>
          </a>
        </div>
      </div>
    </div>
    </>
  );
}

export default Connect;
